export var loadStyle = function loadStyle(href, id) {
  var link = document.createElement('link');
  link.setAttribute('href', href);
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('id', id);

  var head = document.querySelector('head');
  head.appendChild(link);
};